module.exports = __webpack_public_path__ + "static/media/icecream@2x.36498543.png";